<template>
  <div class="login column align-center justify-center">
    <div class="login-background" v-if="background"></div>
    <div class="login-box">
      <div class="login-box-container">
        <div class="align-center column">
          <img src="../../assets/img/logo-supporter-black.png" alt="NS SUPPORT" width="200" />
        </div>
        <div class="mask">
          <div class="mask-scroll row">
            <div class="mask-login" :class="recover || created?'recue':''">
              <div>
                <p>
                  <br />Para se tornar um Supporter e prestar serviços para a NetSupport você deve seguir três passos:
                  <br />
                </p>
                <div class="row align-center">
                  <div class="grid-2 align-center">
                    <img src="../../assets/img/mail.svg" />
                  </div>
                  <div class="grid-9">Informar seu nome completo e e-mail a seguir</div>
                </div>
                <div class="row align-center">
                  <div class="grid-2">
                    <img src="../../assets/img/talk.svg" />
                  </div>
                  <div
                    class="grid-9"
                  >Checar seu e-mail e clicar no link enviado para concluir seu cadastro</div>
                </div>
                <div class="row align-center">
                 <!--  <div class="grid-2">
                    <img src="../../assets/img/slack.svg" />
                  </div>
                  <div class="grid-9">Ativar corretamente sua conta em nosso Slack</div> -->
                </div>
                <div class="row control grid-12 justify-center align-center">
                  <Button layout="green-m" @click="recover = true;" type="button">Ok, ESTOU CIENTE</Button>
                </div>
              </div>
            </div>
            <form
              :class="created?'recue':'recover'"
              onsubmit="return false;"
              @submit="loader=true;CREATE_SUPPORTER(dados).then((r)=>{loader=false;if(r.status===201 || r.status===200)created=true}).catch(()=>loader=false);"
            >
              <div class="row field justify-center">Entre com seus dados para continuar:</div>
              <div class="column field font-12">
                <label for>Nome completo:</label>
                <input
                  type="text"
                  v-model="dados.nome"
                  placeholder="Nome"
                  pattern="(\w.+\s).+"
                  title="Informar nome completo"
                  required
                />
              </div>
              <div class="column field font-12">
                <label for>Seu e-mail:</label>
                <input v-model="dados.email" type="email" placeholder="E-mail" required />
              </div>
              <div class="column field font-12">
                <label for>Seu celular:</label>
                <input
                  v-model="dados.celular"
                  type="text"
                  placeholder="Celular"
                  required
                  v-mask="'(##) #####-####'"
                />
              </div>
              <div class="row control grid-12 justify-center align-center">
                <br />
                <br />

                <Button :loader="loader" layout="green-m" :disabled="loader">ENVIAR CADASTRO</Button>
              </div>
            </form>

            <div v-if="created" class="created column field align-center">
              <br />
              <img src="../../assets/img/mail.svg" width="100" />
              <h3>Deu tudo certo!</h3>
              <p>
                Seu e-mail foi cadastrado com sucesso!
                <br />Confira sua caixa pra completar o cadastro.
              </p>
              <a href="/">
                <Button :loader="loader" layout="green-m" :disabled="loader">Fechar</Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Status />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Api from "@/conf/Api";
import Button from "@/components/Button.vue";
import Status from "@/components/Status.vue";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "NewSupporter",
  components: {
    Button,
    Status
  },
  data() {
    return {
      api: Api,
      isPwd: true,
      dados: {
        nome: "",
        email: "",
        celular: ""
      },
      loader: false,
      recover: false,
      created: false,
      background: true
    };
  },
  methods: {
    ...mapActions("user", ["CREATE_SUPPORTER"])
  },
  beforeMount() {
    this.background = window.innerWidth < 849 ? false : true;
  },
  computed: {
    ...mapGetters("general", ["status"])
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.login {
  .loader {
    margin-left: 150px;
  }
  height: 100vh;
  &-background {
    background-color: $black-1;
    height: 100vh;
    position: absolute;
    width: 100%;
    z-index: -1;

    &::before {
      background: url(../../assets/img/background_login.png) no-repeat center
        center;
      background-size: cover;
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      opacity: 0.3;
    }
  }

  &-box {
    overflow: hidden;
    width: 600px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 15px #222;

    @media (max-width: $small) {
      width: 100%;
      padding-top: 10%;
      height: 100vh;
    }
    @media (min-width: $small) {
      min-width: 500px;
      min-height: 493px;
      border-radius: 10px;
    }

    &-container {
      padding: 40px 47px;
      padding-bottom: 23px;
    }

    .mask {
      width: 100%;

      overflow: hidden;

      &-scroll {
        width: 525%;
      }
      &-login {
        width: 19%;
        float: left;

        img {
          width: 50%;
        }
        .row {
          padding: 10px 0px;
        }
      }
      .recue {
        margin-left: -30%;
      }

      .recover {
        margin-left: 11%;
        width: 18.5%;
      }
      .created {
        @media (max-width: $small) {
          width: 100%;
          left: 0px;
          margin-top: 3rem;
          position: absolute;
        }
        @media (min-width: $small) {
          margin-left: 28.5%;
          width: 20%;

          h3 {
            color: $green-1;
          }
          p {
            text-align: center;
          }
          button {
            margin-top: 40px;
          }
        }
      }
    }
  }

  input {
    background: #fafafa 0% 0% no-repeat padding-box;
    border: 1px solid $white-6;
    border-radius: 5px;
    opacity: 1;
    height: 47px;
    width: 90%;
    padding: 0px 5%;
    margin-top: 7px;
    color: $gray-2;

    &:focus {
      background: $green-3;
      border-bottom: 5px solid $green-2;
    }
  }

  .field {
    margin-top: 19px;
  }
  .see {
    font-size: 26px;
    position: relative;
    color: $gray-2;
    margin-left: -37px;
    margin-top: 20px;
    cursor: pointer;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
  .control {
    margin-top: 40px;
    margin-bottom: 10px;
    .forgot {
      font-size: 13px;
      text-decoration: underline;
      color: $green-4;
    }
  }
  .create {
    border-top: 1px solid $white-6;
    margin-top: 35px;
    padding-top: 25px;
    font-size: 13px;
    text-align: center;
    color: $black-2;
    a {
      color: $green-4;
      text-decoration: underline;
    }
  }

  .error {
    padding-top: 30px;
    color: $red-1;
    text-align: justify;
  }
  .success {
    padding-top: 30px;
    color: $green-2;
    text-align: justify;
  }
}
</style>